/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Japanese
export default {
  'automation-menu.empty-state.image.alt': '空の自動化リストのアイコン',
  'automation-menu.empty-state.learn-more.link': '手動トリガーの詳細をご確認ください',
  'automation-menu.modal.empty.automations.admin.description':
    '手動トリガーをメニューの選択肢として使用すると、ワンクリックの自動化としてユーザー (特定のユーザーを指定することもできる) が適用できるようになります。',
  'automation-menu.modal.empty.automations.user.description':
    '管理者が手動でトリガーされる自動化をまだ設定していません。',
  'automation-menu.modal.error.description': '読み込みにはしばらく時間がかかります。ページを更新してください。',
  'automation-menu.modal.error.image.alt': 'エラー アイコン',
  'automation-menu.modal.footer.automate-button': '自動化',
  'automation-menu.modal.footer.cancel-button': 'キャンセル',
  'automation-menu.modal.footer.get-started-button': '自動化を作成',
  'automation-menu.modal.footer.ok-button': 'OK',
  'automation-menu.modal.header.icon.label': '自動化モーダル ヘッダー アイコン',
  'automation-menu.success-state.message': '自動化を実行中',
  'fabric.linking.access_exists_description':
    '{hostname} からこのコンテンツを閲覧するには、アクセス権をリクエストしてください。',
  'fabric.linking.actions': 'アクション',
  'fabric.linking.add_account': 'アカウントを追加',
  'fabric.linking.ai_summarize': '要約',
  'fabric.linking.ai_summarized': 'Atlassian Intelligence による要約',
  'fabric.linking.ai_summarized_abbreviation': 'AI による要約',
  'fabric.linking.ai_summarized_info': '情報の質は異なる場合があります。<a>詳細をご確認ください</a>',
  'fabric.linking.ai_summarized_info_short': 'コンテンツの質にはばらつきがある場合があります',
  'fabric.linking.ai_summarizing': 'Atlassian Intelligence が作動中...',
  'fabric.linking.ai_summary_action': 'AI で要約',
  'fabric.linking.ai_summary_action_description':
    'Atlassian Intelligence を使用して、このリンクのコンテンツを要約します',
  'fabric.linking.ai_summary_error_acceptable_use_violation':
    'この要約の結果は、<a>アトラシアンの利用規定</a>に反するため、表示できません。',
  'fabric.linking.ai_summary_error_exceeding_context_length_error':
    '要約する内容が多すぎるため、現在 Atlassian Intelligence は要約を生成できません。',
  'fabric.linking.ai_summary_error_generic':
    'Atlassian Intelligence (AI) が応答していません。後でもう一度お試しになるか、<a>AI のステータスを確認してください</a>。',
  'fabric.linking.ai_summary_error_hipaa_content_detected':
    'HIPAA の制限対象となるコンテンツへのリンクが含まれているため、Atlassian Intelligence はリクエストを処理できませんでした。 ',
  'fabric.linking.assigned_to': '割り当て先: {context}',
  'fabric.linking.automation-action.confluence.page.modal.description':
    '<b>{name}</b> に自動化を適用します。{br}選択可能な項目は、Confluence とスペース管理者によって管理されます。',
  'fabric.linking.automation-action.confluence.page.modal.title': 'ページ自動化',
  'fabric.linking.automation-action.icon.label': '自動化アイコン',
  'fabric.linking.automation-action.title': '自動化ルールを表示',
  'fabric.linking.automation-action.tooltip': '実行する自動化ルールを選択',
  'fabric.linking.beta': 'ベータ版',
  'fabric.linking.cancel': 'キャンセル',
  'fabric.linking.cannot_connect': '接続できません、もう一度お試しください。',
  'fabric.linking.cannot_find_link': 'リンクが見つかりません。',
  'fabric.linking.check_this_link': 'このリンクをご確認ください',
  'fabric.linking.click_to_join': '{context} に参加する',
  'fabric.linking.click_to_join_description': '承認されているため、今すぐ {context} に参加できます。',
  'fabric.linking.close': '閉じる',
  'fabric.linking.connect_account_description': '{name} アカウントを接続するため、新しいページを開きます',
  'fabric.linking.connect_link_account': '接続してプレビュー',
  'fabric.linking.connect_link_account_card_view': '接続',
  'fabric.linking.connect_link_account_card_view_description':
    'このリンクのプレビューを表示するには {context} アカウントを接続してください。',
  'fabric.linking.connect_link_account_card_view_name': 'ご使用の {context} アカウントを接続',
  'fabric.linking.connect_to': '{name} に接続',
  'fabric.linking.connect_unauthorised_account_action': '{context} に接続',
  'fabric.linking.connect_unauthorised_account_description':
    '{context} アカウントを接続すると、アトラシアン製品全体でコラボレーションできます。',
  'fabric.linking.connect_unauthorised_account_description_no_provider':
    'アカウントを接続すると、アトラシアン製品全体でコラボレーションできます。',
  'fabric.linking.continue': '続行',
  'fabric.linking.copied_summary_action_description': '要約をクリップボードにコピーしました',
  'fabric.linking.copied_url_to_clipboard': 'コピーしました',
  'fabric.linking.copy_summary_action': '要約をコピー',
  'fabric.linking.copy_summary_action_description': '要約をコピー',
  'fabric.linking.copy_url_to_clipboard': 'リンクをコピー',
  'fabric.linking.couldnt_load_link': '不明な理由によって、このリンクを読み込めませんでした。',
  'fabric.linking.create_on_absolute': '作成日: {context}',
  'fabric.linking.create_on_relative': '作成日: {context}',
  'fabric.linking.created_by': '作成元: {context}',
  'fabric.linking.delete': '削除',
  'fabric.linking.direct_access': '今すぐ参加する',
  'fabric.linking.direct_access_description':
    'あなたのチームは {product} を使用してコラボレーションしています。あなたも今すぐ使用を開始できます！',
  'fabric.linking.direct_access_title': '{product} に参加してこのコンテンツを閲覧する',
  'fabric.linking.download': 'ダウンロード',
  'fabric.linking.download_description': 'このファイルをローカル ストレージにダウンロードします',
  'fabric.linking.download_file': 'ファイルをダウンロード',
  'fabric.linking.edit': '編集',
  'fabric.linking.follow': 'フォロー',
  'fabric.linking.follow_goal': 'ゴールをフォロー',
  'fabric.linking.follow_goal_description': 'このゴールをフォローすると、最新情報の通知が届きます',
  'fabric.linking.follow_goal_error':
    'ゴールをフォローする際にエラーが発生しました。接続を確認するか、ページを更新してもう一度お試しください。',
  'fabric.linking.follow_project': 'プロジェクトをフォロー',
  'fabric.linking.follow_project-galaxia': 'スペースをフォロー',
  'fabric.linking.follow_project_description': 'フォローすると、このプロジェクトの通知が届きます',
  'fabric.linking.follow_project_description-galaxia': 'フォローすると、このスペースの通知が届きます',
  'fabric.linking.follow_project_error':
    'プロジェクトをフォローする際にエラーが発生しました。接続を確認するか、ページを更新してもう一度お試しください。',
  'fabric.linking.follow_project_error-galaxia':
    'スペースをフォローする際にエラーが発生しました。接続を確認するか、ページを更新してもう一度お試しください。',
  'fabric.linking.forbidden_access': 'アクセスは禁止されています。',
  'fabric.linking.forbidden_description': '{hostname} へのアクセス権をリクエストするには、管理者に連絡してください。',
  'fabric.linking.forbidden_title': 'このコンテンツへのアクセス権がありません',
  'fabric.linking.generic_error_message': 'エラーが発生しました',
  'fabric.linking.go_back': '戻る',
  'fabric.linking.invalid_permissions': '制限付きコンテンツ',
  'fabric.linking.invalid_permissions_description':
    'このプレビューを表示するには、アクセスをリクエストするか別のアカウントで試してください。',
  'fabric.linking.join_to_view': '{context}に参加してこの課題を見る',
  'fabric.linking.join_to_view-issue-term-refresh': '{context} に参加してこの作業項目を見る',
  'fabric.linking.learn_more_about_connecting_account': 'アカウントをアトラシアン製品に接続する方法をご確認ください。',
  'fabric.linking.learn_more_about_smart_links': 'スマート リンクの詳細',
  'fabric.linking.link_safety_warning_message':
    'リンク {unsafeLinkText} をクリックすると別のサイトが開きます。<a>実際のリンク先</a>',
  'fabric.linking.loading': '読み込み中…',
  'fabric.linking.modified_on_absolute': '更新日: {context}',
  'fabric.linking.modified_on_relative': '更新日: {context}',
  'fabric.linking.more_actions': 'その他のアクション',
  'fabric.linking.no_access_title': '{product} に参加してこのコンテンツを閲覧する',
  'fabric.linking.not_found_description': 'ページが存在しないか、このリンクの追加後に変更された可能性があります。',
  'fabric.linking.not_found_title': 'この {product} のページは表示できません',
  'fabric.linking.open_issue_in_jira': 'Jira で課題を開く',
  'fabric.linking.open_issue_in_jira-issue-term-refresh': 'Jira で作業項目を開く',
  'fabric.linking.open_link_in_a_new_tab': 'リンクを新しいタブで開く',
  'fabric.linking.owned_by': '所有者: {context}',
  'fabric.linking.owned_by_override': '所有者: {context}',
  'fabric.linking.pending_request': 'アクセス リクエストは保留中です。',
  'fabric.linking.preview_close': 'プレビューを閉じる',
  'fabric.linking.preview_description': 'このリンクの全画面プレビューを開きます',
  'fabric.linking.preview_improved': 'プレビューを開く',
  'fabric.linking.preview_max_size': '全画面表示',
  'fabric.linking.preview_min_size': '全画面表示を閉じる',
  'fabric.linking.preview_modal': 'プレビュー モーダルを開く',
  'fabric.linking.preview_panel': 'プレビュー パネルを開く',
  'fabric.linking.priority_blocker': 'ブロッカー',
  'fabric.linking.priority_critical': 'クリティカル',
  'fabric.linking.priority_high': '高',
  'fabric.linking.priority_highest': '最高',
  'fabric.linking.priority_low': '低',
  'fabric.linking.priority_lowest': '最低',
  'fabric.linking.priority_major': 'メジャー',
  'fabric.linking.priority_medium': '中',
  'fabric.linking.priority_minor': 'マイナー',
  'fabric.linking.priority_trivial': '軽度',
  'fabric.linking.priority_undefined': '未定義',
  'fabric.linking.read_time': '読了時間 {context} 分',
  'fabric.linking.related': '関連',
  'fabric.linking.related_links_found_in': 'ソース元',
  'fabric.linking.related_links_includes_links_to': '次へのリンクが含まれています',
  'fabric.linking.related_links_modal_error_description': '接続を確認するか、ページを更新してもう一度お試しください',
  'fabric.linking.related_links_modal_error_title': '関連リンクの読み込み中に問題が発生しました',
  'fabric.linking.related_links_modal_title': '関連リンク',
  'fabric.linking.related_links_modal_unavailable_description':
    '更新されたページやその他のコンテンツ タイプについて継続的に確認し、関連リンクを追加していきます',
  'fabric.linking.related_links_modal_unavailable_title': '関連リンクが見つかりませんでした',
  'fabric.linking.related_links_not_found': 'ここに表示するリンクが見つかりませんでした。',
  'fabric.linking.related_links_view_related_links': '関連リンクを表示',
  'fabric.linking.related_links_view_related_urls': '最近のリンクを表示',
  'fabric.linking.request_access': 'アクセスをリクエスト',
  'fabric.linking.request_access_description':
    'あなたのチームは {product} を使用してコラボレーションしています。管理者にアクセス権をリクエストしてください。',
  'fabric.linking.request_access_pending': '承認待ち',
  'fabric.linking.request_access_pending_description': '{hostname} へのアクセス権のリクエストは管理者の承認待ちです。',
  'fabric.linking.request_access_pending_title': '{product} へのアクセス権は保留中です',
  'fabric.linking.request_access_to_view': 'この課題を表示するには、{context}へのアクセスをリクエストします。',
  'fabric.linking.request_access_to_view-issue-term-refresh':
    'この作業項目を表示するには、{context} へのアクセスをリクエストします。',
  'fabric.linking.request_denied': 'アクセス リクエストが拒否されました。',
  'fabric.linking.request_denied_description':
    '{hostname} の {product} ページを閲覧するリクエストが管理者によって承認されませんでした。',
  'fabric.linking.restricted_link': '制限されているリンクです、別のアカウントをお試しください。',
  'fabric.linking.retry': '再試行',
  'fabric.linking.save': '保存',
  'fabric.linking.sent_on_absolute': '{context} に送信済み',
  'fabric.linking.sent_on_relative': '{context}に送信済み',
  'fabric.linking.srclink': '次で表示',
  'fabric.linking.srclinkunknown': 'リンク元を表示',
  'fabric.linking.status_change_load_error': 'ステータスとトランジションを読み込めませんでした。',
  'fabric.linking.status_change_permission_error': 'この課題をトランジションする権限がありません。',
  'fabric.linking.status_change_permission_error-issue-term-refresh':
    'この作業項目をトランジションする権限がありません。',
  'fabric.linking.status_change_update_error': 'ステータスを更新できませんでした。',
  'fabric.linking.team_members_count': '{context} 人のメンバー',
  'fabric.linking.try_again': '再試行',
  'fabric.linking.try_another_account': '別のアカウントでお試しください',
  'fabric.linking.unassigned': '未割り当て',
  'fabric.linking.unauthorised_account_description':
    '{context} の非公開ページへのリンクをプレビューしようとしています。URL を確認するか、ページの所有者に問い合わせることをお勧めします。',
  'fabric.linking.unauthorised_account_description_no_provider':
    '非公開ページへのリンクをプレビューしようとしています。URL を確認するか、ページの所有者に問い合わせることをお勧めします。',
  'fabric.linking.unauthorised_account_name': '{context} の非公開ページは表示できません',
  'fabric.linking.unauthorised_account_name_no_provider': '非公開ページは表示できません',
  'fabric.linking.unfollow': 'フォローを解除',
  'fabric.linking.unfollow_goal': 'ゴールをフォロー解除',
  'fabric.linking.unfollow_goal_description': 'フォロー解除すると、このゴールの通知が届かなくなります',
  'fabric.linking.unfollow_goal_error':
    'ゴールをフォロー解除する際にエラーが発生しました。接続を確認するか、ページを更新してもう一度お試しください。',
  'fabric.linking.unfollow_project': 'プロジェクトをフォロー解除',
  'fabric.linking.unfollow_project-galaxia': 'スペースをフォロー解除',
  'fabric.linking.unfollow_project_description': 'フォロー解除すると、プロジェクトの通知が届かなくなります',
  'fabric.linking.unfollow_project_description-galaxia': 'フォロー解除すると、スペースの通知が届かなくなります',
  'fabric.linking.unfollow_project_error':
    'プロジェクトをフォロー解除する際にエラーが発生しました。接続を確認するか、ページを更新してもう一度お試しください。',
  'fabric.linking.unfollow_project_error-galaxia':
    'スペースをフォロー解除する際にエラーが発生しました。接続を確認するか、ページを更新してもう一度お試しください。',
  'fabric.linking.unlink_account': 'アカウントのリンクを解除',
  'fabric.linking.updated_by': '変更元: {context}',
  'fabric.linking.user_attributes': '{context}',
  'fabric.linking.view': '表示',
};
